export const components = {
  BackstageInfoCard: {
    styleOverrides: {
      header: ({ theme }: { theme: any }) => ({
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.surfaceContainer.container,

        '& .MuiDivider-root': {
          visibility: 'hidden',
        },
      }),
    },
  },
};
